import React, { useState } from "react";
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import GetCustomers from "../customers/get_customers";
import GetProducts from "../products/get_products";
import Button from "react-bootstrap/Button";

function NewSpecialRoll(){
  // Order number
  var OrderNumber = 0;
  const setOrderNumber = () => {
    var OrderNumber_select = document.getElementById('Order_Number');
    OrderNumber = OrderNumber_select.value;
  }
  // Customer
  var Customer = 0;
  const Customers = GetCustomers();
  const handleCustomerChange = (event) => {
    Customer = event.value;
  }

  // Product
  var Product = 0;
  const Products = GetProducts("Roll");
  const handleProductChange = (event) => {
    var product_id = event.value;
    Product = Products.find(product => product.id == product_id);
  }

  // Product info
  var ProductWidth = 0;
  const handleProductWidthChange = () => {
    var ProductWidth_select = document.getElementById('ProductWidth');
    ProductWidth = ProductWidth_select.value;
  };

  var ProductLength = 0;
  const handleProductLengthChange = () => {
    var ProductLength_select = document.getElementById('ProductLength');
    ProductLength = ProductLength_select.value;
  };

  // Building
  const Buildings = [
    { label: 'Warehouse', value: 'Warehouse' },
    { label: 'Shop', value: 'Shop' }
  ];

  var Building = "";
  const handleBuildingChange = (event) => {
    Building = event.value;
  };

  // Location
  var Location = "";
  const handleLocationChange = () => {
    var Location_select = document.getElementById('Location_ID');
    Location = Location_select.value;
  };

  var myData = "";
  const submitSpecial = async () => {
    myData = {
      stock: {
        stock_type_type: "StockFlooringRoll",
        order_number: OrderNumber,
        customer_id: Customer,
        product_id: Product.id,
        building: Building,
        location: Location
      },
      stock_type: {
        product_width: ProductWidth,
        product_length: ProductLength,
      }
    }

    const result = await fetch(import.meta.env.VITE_URL + '/specials', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(myData)
      })
      const resultInJson = await result.json()
  }

  return (

    <Form>
      <div>
        <Form.Text id="d" muted>
          Enter the Order Reference for this Special Item.
            <Form.Control
              type="string"
              min="0"
              placeholder="Order Reference"
              id="Order_Number"
              onChange={setOrderNumber}
              required
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Select the customer this special belongs to
            <Select
              options={Customers.map(opt => ({ label: opt.customerdisplayname, value: opt.id }))}
              onChange={event => handleCustomerChange(event)}
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Select the Product
            <Select
              options={Products.map(opt => ({ label: opt.name, value: opt.id}))}
              onChange={event => handleProductChange(event)}
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
            Enter the Product Length for this Product.
              <Form.Control
                type="string"
                placeholder="Product Length"
                id="ProductLength"
                onChange={handleProductLengthChange}
                required
              />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Enter the Product Width for this Product.
            <Form.Control
              type="number"
              min="0"
              step="0.01"
              placeholder="Product Width"
              id="ProductWidth"
              onChange={handleProductWidthChange}
              required
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Select the Building the Special is located
            <Select
              options={Buildings}
              onChange={event => handleBuildingChange(event)}
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Enter the Positional Location of the Special Item.
            <Form.Control
              type="string"
              id="Location_ID"
              placeholder="Positional Location"
              onChange={handleLocationChange}
            />
        </Form.Text>
      </div>
      <div className="mt-3">
        <Button type="submit" onClick={submitSpecial}>Submit form</Button>
      </div>

    </Form>

  )

}
export default NewSpecialRoll
